import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/workspace/$workspaceId/insight/')({
  beforeLoad: ({ search, params }) => {
    throw redirect({
      to: '/workspace/$workspaceId/insight/overview',
      params: {
        workspaceId: params.workspaceId,
      },
      search: {
        q: search.q,
      },
    });
  },
});
